import { render } from "./ForgeAuth.vue?vue&type=template&id=76d870b5"
import script from "./ForgeAuth.vue?vue&type=script&lang=js"
export * from "./ForgeAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__